import { marketingConsentGranted } from './marketingConsent';
import { getAttribution, webDistinctId } from './attribution';

export const hasMarketingConsent = marketingConsentGranted;
function checkoutClientId(): string | undefined {
  try {
    const cookie = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith('_ga='));
    const value = cookie?.slice(4).match(/^GA\d+\.\d+\.(\d{1,16}\.\d{1,16})$/)?.[1];
    return value;
  } catch { return undefined; }
}
/**
 * One consent snapshot for the request, plus the attribution the payment
 * must carry whatever that consent says: the stored { first, last } touches,
 * the GA client id when the cookie exists, and the web PostHog anonymous id
 * (`ph_did`) so the sale joins back to this visitor. Storage of these on our
 * own Stripe metadata is not gated (owner call, 2026-10-21); the ad-platform
 * sends still read `marketing_consent` at send time.
 */
export function checkoutTrackingMetadata() {
  const granted = hasMarketingConsent();
  const attribution = getAttribution();
  const client = checkoutClientId();
  const phDid = webDistinctId();
  const withClient = client ? { ...attribution, last: { ...attribution?.last, ga_client_id: client } } : attribution;
  const hasTouch = !!(withClient && (withClient.first || withClient.last));
  return { marketing_consent: granted ? 'granted' as const : 'denied' as const,
    ...(hasTouch ? { attribution: withClient } : {}),
    ...(phDid ? { ph_did: phDid } : {}) };
}
/** Keep Stripe's literal template rather than URL-encoding its braces. */
export function checkoutSuccessUrl(url: string): string {
  const parsed = new URL(url);
  parsed.searchParams.set('session_id', '{CHECKOUT_SESSION_ID}');
  return parsed.toString().replace('%7BCHECKOUT_SESSION_ID%7D', '{CHECKOUT_SESSION_ID}');
}
